import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const commandPaletteOpenAtom = atom(false);

export type ProjectDialogState = { mode: "create" } | { mode: "edit"; projectId: string } | null;
export const projectDialogAtom = atom<ProjectDialogState>(null);

export const sidebarCollapsedAtom = atomWithStorage(
	"gridcast:sidebar-collapsed",
	false,
	undefined,
	{
		getOnInit: true,
	},
);
